/* sc-cart-edit-design.js — cart "Edit Design" trigger for inhouse PZ lines.
 * Loads the PZ cart editor runtime (pz-cart-edit-modal.js, config.pzModalSrc) on first intent
 * (hover/mount prewarm, or click) and lets the trigger's own click open the modal once installed.
 * A page owned by another renderer (Customily fabric) never installs it.
 * 03/09: the CustomAll SDK editor bridge, its review/price sync and the CustomAll cart Edit Save
 * lifecycle (fetch wrapper) that used to live here were removed with the app. */
(function () {
  'use strict';

  if (window.__scCartEditDesignInstalled) return;
  window.__scCartEditDesignInstalled = true;

  var PZ_TRIGGER_SELECTOR = '[data-pz-cart-edit-trigger]';
  var PZ_MODAL_TIMEOUT_MS = 15000;
  var config = window.scCartEditDesignConfig || {};
  var pzModalSrc = config.pzModalSrc || '';
  var pzModalFlight = null;

  function foreignRendererOwnsPage() {
    if (window.__pzBootstrap) return false;
    var shell = document.querySelector('[data-pz-cart-edit-modal]');
    var declared = shell ? shell.getAttribute('data-pz-cart-edit-foreign-renderer') : null;
    if (declared === 'true') return true;
    if (declared === 'false') return false;
    return typeof window.fabric !== 'undefined';
  }

  function ensurePzModalRuntime() {
    if (window.__pzCartEditModalInstalled) return Promise.resolve(true);
    if (pzModalFlight) return pzModalFlight;
    if (!pzModalSrc) return Promise.reject(new Error('PZ cart editor source missing'));
    pzModalFlight = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var settled = false;
      var timer = window.setTimeout(function () {
        finish(new Error('PZ cart editor timed out'));
      }, PZ_MODAL_TIMEOUT_MS);
      function finish(error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        script.onload = null;
        script.onerror = null;
        if (error) {
          script.remove();
          reject(error);
        } else {
          resolve(true);
        }
      }
      script.src = pzModalSrc;
      script.async = true;
      script.setAttribute('data-pz-cart-edit-loader', '');
      script.onload = function () {
        if (window.__pzCartEditModalInstalled) finish();
        else finish(new Error('PZ cart editor failed to install'));
      };
      script.onerror = function () { finish(new Error('PZ cart editor failed to load')); };
      (document.head || document.documentElement).appendChild(script);
    }).catch(function (error) {
      pzModalFlight = null;
      throw error;
    });
    return pzModalFlight;
  }

  function setPzTriggerPending(trigger, pending) {
    if (!trigger || !trigger.classList) return;
    trigger.classList.toggle('is-opening', !!pending);
    if (pending) trigger.setAttribute('aria-busy', 'true');
    else trigger.removeAttribute('aria-busy');
  }

  function prewarmPzTrigger(trigger) {
    if (!trigger || !trigger.matches || !trigger.matches(PZ_TRIGGER_SELECTOR)) {
      return Promise.resolve(false);
    }
    // Prewarming loads the very runtime that publishes Fabric, so the gate belongs here as well as
    // on the click — otherwise a trigger appearing on a page another renderer owns would install it.
    if (foreignRendererOwnsPage()) return Promise.resolve(false);
    return ensurePzModalRuntime().then(function () {
      if (typeof window.__pzCartEditModalPrefetch !== 'function') return false;
      return window.__pzCartEditModalPrefetch(trigger);
    });
  }

  function prewarmPzTriggers(rootNode) {
    if (!rootNode) return false;
    var triggers = [];
    if (rootNode.matches && rootNode.matches(PZ_TRIGGER_SELECTOR)) triggers.push(rootNode);
    if (rootNode.querySelectorAll) {
      triggers = triggers.concat(Array.prototype.slice.call(rootNode.querySelectorAll(PZ_TRIGGER_SELECTOR)));
    }
    triggers.forEach(function (trigger) {
      prewarmPzTrigger(trigger).catch(function () { /* click keeps the safe navigation fallback */ });
    });
    return triggers.length > 0;
  }

  function onDocumentClick(event) {
    var target = event.target;
    var trigger = target && target.closest ? target.closest(PZ_TRIGGER_SELECTOR) : null;
    if (!trigger) return;
    if (window.__pzCartEditModalInstalled) return;
    if (foreignRendererOwnsPage()) return;
    event.preventDefault();
    setPzTriggerPending(trigger, true);
    ensurePzModalRuntime().then(function () {
      setPzTriggerPending(trigger, false);
      if (document.contains(trigger)) trigger.click();
    }).catch(function () {
      setPzTriggerPending(trigger, false);
      if (trigger.href) window.location.href = trigger.href;
    });
  }

  document.addEventListener('click', onDocumentClick);

  var observer = new MutationObserver(function (mutations) {
    for (var mutationIndex = 0; mutationIndex < mutations.length; mutationIndex += 1) {
      var addedNodes = mutations[mutationIndex].addedNodes;
      for (var nodeIndex = 0; nodeIndex < addedNodes.length; nodeIndex += 1) {
        prewarmPzTriggers(addedNodes[nodeIndex]);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  prewarmPzTriggers(document);
})();
